export default "__VITE_ASSET__C$vsYU71__"